var onlyDigitsLength = function (value) {
    return value.replace(/\D+/g, "").length;
};
export default onlyDigitsLength;
